/*
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-08-27 20:28:45
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-09-26 16:56:36
 * @FilePath: /b2c_public_components/src/apis/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Fetch from '../request'
const host = 'https://app.zhuanzhuan.com'
const API = {
  getQcHelpfulCount: `${host}/zzopen/hypermall/getQcHelpfulCount`, // $ 获取帮助信息
  incrQcHelpfulCount: `${host}/zzopen/hypermall/incrQcHelpfulCount`, // $ 增加有帮助数值
  getQcItemFeedbackInfo: `${host}/zzopen/hypermall/getQcItemFeedbackInfo`, // $ 获取质检项的反馈项信息
  submitQcItemFeedback: `${host}/zzopen/hypermall/submitQcItemFeedback`, // $ 提交质检项反馈
  reportInfoByOrder: `${host}/zzopen/waresshow/reportInfoByOrder`, // 通过omsSkuid获取质检报告信息
  getCommitment: `${host}/zzopen/waresshow/getCommitment`, // 质检报告官方验弹窗
  getExplain: `${host}/zzopen/waresshow/getExplain`,
  reportPushChannelStatus: `${host}/zz/v2/zzlogic/reportPushChannelStatus`, // 新触达通道用户事件上报
  receiveByOcdPlanId: `${host}/zzopen/b2cmall_msgcenter/receiveByOcdPlanId`, // 一键领取OCD
  receiveByTouchId: `${host}/zzopen/b2cmall_msgcenter/receiveByTouchId`, // 一键领取普通券
  receiveCoupon: `${host}/zzopen/hypermall/receiveCoupon`, // 领取单个红包
  operateTouchOrder: `${host}/zzopen/b2cmall_msgcenter/operateTouchOrder`, // 叠加券场景
  orderAdInfo: `${host}/zzopen/hypermall/orderAdInfo`, // 订单相关运营信息
  freeMarket: `${host}/zzopen/freemarket/listData`, // 自由市场feed流
  getbusinessinfobytype: `${host}/zz/transfer/getbusinessinfobytype`, // 资质信息查询
  getOrderDetail: `${host}/zzopen/waresshow/getLuxuryReportVo`, // 订单快照质检报告
}

// $ 新触达通道用户事件上报
export const operateTouchOrder = (params) => {
  return Fetch.get({
    url: API.operateTouchOrder,
    params: {
      ...params,
    },
  })
}

// $ 新触达通道用户事件上报
export const reportPushChannelStatus = (params) => {
  return Fetch.get({
    url: API.reportPushChannelStatus,
    params: {
      ...params,
    },
  })
}

// $ 一键领取OCD触达信息对应红包
export const receiveByOcdPlanId = (params) => {
  return Fetch.get({
    url: API.receiveByOcdPlanId,
    params: {
      ...params,
    },
  })
}

// $ 领取免费红包
export const receiveCoupon = (params) => {
  return Fetch.get({
    url: API.receiveCoupon,
    params: {
      ...params,
    },
  })
}

// $ 一键领取触达信息对应红包
export const receiveByTouchId = (params) => {
  return Fetch.get({
    url: API.receiveByTouchId,
    params: {
      ...params,
    },
  })
}

// $ 获取帮助信息
export const getQcHelpfulCount = (params) => {
  return Fetch.get({
    url: API.getQcHelpfulCount,
    params: {
      ...params,
    },
  })
}
// $ 增加有帮助数值
export const incrQcHelpfulCount = (params) => {
  return Fetch.post({
    url: API.incrQcHelpfulCount,
    params: {
      ...params,
    },
  })
}
// $ 获取质检项的反馈项信息
export const getQcItemFeedbackInfo = (params) => {
  return Fetch.post({
    url: API.getQcItemFeedbackInfo,
    params: {
      ...params,
    },
  })
}

// $ 提交质检项反馈
export const submitQcItemFeedback = (params) => {
  return Fetch.post({
    url: API.submitQcItemFeedback,
    params: {
      ...params,
    },
  })
}

export const getReportInfoByOrder = (params) => {
  return Fetch.get({
    url: API.reportInfoByOrder,
    params: {
      ...params,
    },
  })
}

export const getCommitment = () => {
  return Fetch.get({
    url: API.getCommitment,
  })
}

export const getExplain = (params) => {
  return Fetch.get({
    url: API.getExplain,
    params: {
      ...params,
    },
  })
}

/**
 * $ 订单相关运营信息
 * @returns { imgUrl jumpUrl }
 */
export const getOrderAdInfo = (params) => {
  return Fetch.post({
    url: API.orderAdInfo,
    params: {
      ...params,
    },
  })
}

//自由市场feed流数据
export const getFreeMarket = (params) => {
  return Fetch.post({
    url: API.freeMarket,
    params: {
      ...params,
    },
  })
}

export const getbusinessinfobytype = (params) => {
  return Fetch.post({
    url: API.getbusinessinfobytype,
    params: {
      ...params,
    },
  })
}

export const getOrderDetail = (params) => {
  return Fetch.post({
    url: API.getOrderDetail,
    params: {
      ...params,
    },
  })
}
